module.exports = __webpack_public_path__ + "img/ps.2c30d586.svg";